import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItem',
  props: {
    menu: null
  },
  setup: function (__props) {
    var props = __props;
    return function (_ctx, _cache) {
      var _component_el_menu_item = _resolveComponent("el-menu-item");
      var _component_router_link = _resolveComponent("router-link");
      var _component_menu_item = _resolveComponent("menu-item", true);
      var _component_el_sub_menu = _resolveComponent("el-sub-menu");
      return !props.menu.children ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: __props.menu.path
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_menu_item, {
            index: __props.menu.path
          }, {
            title: _withCtx(function () {
              return [_createElementVNode("span", null, _toDisplayString(__props.menu.title), 1)];
            }),
            _: 1
          }, 8, ["index"])];
        }),
        _: 1
      }, 8, ["to"])) : (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 1,
        index: __props.menu.path
      }, {
        title: _withCtx(function () {
          return [_createElementVNode("span", null, _toDisplayString(__props.menu.title), 1)];
        }),
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu.children, function (child) {
            return _openBlock(), _createBlock(_component_menu_item, {
              key: child.name,
              menu: child
            }, null, 8, ["menu"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["index"]));
    };
  }
});